import styled from 'styled-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxRadio } from 'shared/components';
import { SizeFilterProductType } from 'search/components/searchGrid/SearchFilterSizeMobileProductType';
import { transformSizeFacet } from 'search/utils/sizeFilterUtils';

export const SearchFilterSizeMobile = ({
  facet,
  selectedFilterValues,
  setSelectedFilterValues,
}) => {
  const { t } = useTranslation();
  const transformedSizes = transformSizeFacet(facet.options);
  const [showSizeConversions, setShowSizeConversions] = useState(true);

  const handleSetShowSizeConversionsChange = () => {
    setShowSizeConversions((prevState) => !prevState);
  };

  return (
    <>
      <SearchFilterSizeMobile.CheckboxRadio
        data-qa="show_size_conversions_checkbox"
        checked={showSizeConversions}
        id="show_size_conversions"
        label={t('search.showSizeConversions', 'Show size conversions')}
        labelStyle={{ fontSize: '11px' }}
        name="showSizeConversions"
        onChange={handleSetShowSizeConversionsChange}
        type="checkbox"
        value={showSizeConversions.toString()}
      />
      {Object.keys(transformedSizes).map((productType) => (
        <SizeFilterProductType
          key={productType}
          productType={productType}
          selectedFilterValues={selectedFilterValues}
          setSelectedFilterValues={setSelectedFilterValues}
          sizeOptions={transformedSizes[productType]}
          showSizeConversions={showSizeConversions}
        />
      ))}
    </>
  );
};

SearchFilterSizeMobile.CheckboxRadio = styled(CheckboxRadio)`
  flex-direction: row-reverse;
  justify-content: start;
  > span {
    margin-right: 8px;
  }
`;
